import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class AchievementActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/RealEstate/Achievement/AchievementBrowser")
	}

	render() {
		return (
			<Activity 
				name="Achievement"
				RenderedComponent={this.RenderedComponent}
				context="Achievement"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(AchievementActivity)
